export default __webpack_public_path__ + "69b3d1643006f59f62f5a08020b8bcf1.webp";